import { Component, OnInit, ViewChild } from '@angular/core';
import { DiagnosisOptions } from './interfaces/diagnosis-interface';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { SharedService } from 'app/modules/common/services/shared-service';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';

@Component({
    selector: 'app-diagnosis-filter',
    templateUrl: './diagnosis-filter.component.html',
    styleUrls: ['./diagnosis-filter.component.scss'],
    standalone: false
})
export class DiagnosisFilterComponent implements OnInit {

  @ViewChild(MatMenuTrigger) diagnosisMenu: MatMenuTrigger;

  public DiagnosisListNested$: DiagnosisOptions[];

  constructor(
    public selectionService: SelectionGenericService,
    public sharedService: SharedService, 
    public filterService: FilterService) { }

  ngOnInit(): void {
    this.selectionService.GetDiagnosisTree().subscribe(res => {
      this.DiagnosisListNested$ = res.result;
    }, error => {
      console.error(error);
    });

    this.initializeControls();
  }

  initializeControls(): void {
    if (this.sharedService.selectedSelectionTabId === 2) {
      const from = this.selectionService.leaveSelectionModal.DiagnosisFrom === '' ? null : this.selectionService.leaveSelectionModal.DiagnosisFrom;
      const to = this.selectionService.leaveSelectionModal.DiagnosisTo === '' ? null : this.selectionService.leaveSelectionModal.DiagnosisTo;

      this.filterService.DiagnosisFrom.setValue(from);
      this.filterService.DiagnosisTo.setValue(to);
    }
  }

  setSelectedDiagnosis(diagnosis: DiagnosisOptions): any {
    this.filterService.DiagnosisFrom.setValue(diagnosis.start);
    this.filterService.DiagnosisTo.setValue(diagnosis.end);

    this.submitDiagnosis();
    this.diagnosisMenu.closeMenu();
  }

  submitDiagnosis(inputType = ''): void {
    switch (inputType) {
      case 'From':
        this.selectionService.leaveSelectionModal.DiagnosisFrom = this.filterService.DiagnosisFrom.value;
        break;

      case 'To':
        this.selectionService.leaveSelectionModal.DiagnosisTo = this.filterService.DiagnosisTo.value;
        break;

      default:
        this.selectionService.leaveSelectionModal.DiagnosisFrom = this.filterService.DiagnosisFrom.value;
        this.selectionService.leaveSelectionModal.DiagnosisTo = this.filterService.DiagnosisTo.value;
        break;
    }
  }

}
